import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import auth from './middleware/auth'
import middlewarePipeline from './pipelines'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    meta: {
      middleware: [auth]
    },
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/Admin/LogIn',
    name: 'Login',
    component: () => import('../components/Admin/LogIn.vue')
  },
  {
    path: '/activities',
    name: 'Activities',
    meta: {
      middleware: [auth]
    },
    component: () => import('../views/Activities.vue')
  },
  {
    path: '/logout',
    name: 'Logout'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
      return next()
  }
  const middleware = to.meta.middleware

  const context = {
      to,
      from,
      next,
      store
  }


  return middleware[0]({
      ...context,
      next: middlewarePipeline(context, middleware, 1)
  })

})

export default router
